
import { AuthStepsEnum, PaywallPlans, SiteLinks } from "../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallState } from "./premiumPaywallMobile";
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { PremiumPaywallMobileSignupPassword } from "./signup/premiumPaywallMobileSignupPassword";
import PremiumPaywallCheckoutPlans from "../desktop/premiumPaywallPlans";
import { PremiumPaywalllMobileSignupEmail } from "./signup/premiumPaywallMobileSignupEmail";
import { useState, useEffect } from "react";


interface PremiumPaywallMobileSignUpProps {
  emailOrPhone: string
  password: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void;
  scrollToForm: any;

}

declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}

export const PremiumPaywallMobileSignUp = (props: PremiumPaywallMobileSignUpProps) => {
  const purchaseUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.purchase : '';
  const [selectedUrl, setSelectedUrl] = useState<string>(purchaseUrl);
  const { emailOrPhone, setEmailOrPhone, password, setPassword, setMode, agreesTerms, setAgreesTerms,scrollToForm} = props

  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    resetAuth,
    proceedToEmailStep,
    setAuthError
  } = getAuthHookFactory("signup", AuthStepsEnum.PLANS)();

  const sendMail = () => {
    sendEmailOrPhoneForLogin(emailOrPhone, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  
  useEffect(() => {
    if (step === AuthStepsEnum.CONFIRM_TERMS && agreesTerms) {
      onThirdPartyLogin(agreesTerms)
    }
  }, [step]);

  const handleSelectPlan = (selectedPlan: string | null): string => {
    if (!selectedPlan || !purchaseUrl) return '';
    const url = new URL(purchaseUrl, window.location.origin);
    url.searchParams.set('selected', selectedPlan);
    setSelectedUrl(url.toString());
    return url.toString();
  };
  

  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
          handleSelectPlan={handleSelectPlan}
          setMode={setMode}
          proceedToEmailStep={proceedToEmailStep}
          selectedUrl={selectedUrl}
          scrollToForm={scrollToForm}
        />)
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywalllMobileSignupEmail
          emailOrPhone={emailOrPhone}
          agreesTerms={agreesTerms}
          setEmailOrPhone={setEmailOrPhone}
          setAgreesTerms={setAgreesTerms}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          setAuthError={setAuthError}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallMobileSignupPassword
          emailOrPhone={emailOrPhone}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          sendMail={sendMail}
          authError={authError}
        />
      )
      
    case AuthStepsEnum.FINISH:
      location.href = selectedUrl || '';
      return null;

    default:
      return null
  }
};
